import { render, staticRenderFns } from "./CmgLargeOrderPromoCard.vue?vue&type=template&id=875ea7bc&scoped=true&lang=pug&"
import script from "./cmg-large-order-promo-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-large-order-promo-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLargeOrderPromoCard.vue?vue&type=style&index=0&id=875ea7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ea7bc",
  null
  
)

export default component.exports